module.exports = "/_next/static/images/vincentattonito-978e17f0079f85c88e1129cc95d4578f.jpg";